import { HelmetDexteel } from "@dexteel/mesf-core";
import { LastTurnedRollsReport } from "./components/LastTurnedRollsReport";

export const LastTurnedRollsPage = () => {
	return (
		<>
			<HelmetDexteel title="Last Turned Rolls" />
			<LastTurnedRollsReport />
		</>
	);
};
